import React from "react";
import { Div, Text, Button, Image } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import AnimateLink from "../common/AnimateLink";

const PodcastHero = () => {
  return (
    <Div
      h={{ xs: "100%", md: "75vh" }}
      bg="linear-gradient(223.53deg, #E139C2 1.13%, #6F56FF 65.69%, #4C75F2 98.7%)"
      p={{ xs: "6.375rem 0 3.25rem", md: "0" }}
    >
      <Div d="flex" justify="center" align="center" h="100%">
        <WebsiteContainer>
          <CustomContainer>
            <Div className="podcast-hero-grid" h="100%">
              <Div m="auto 0" order={{ xs: 2, md: 1 }}>
                <Text
                  textWeight="800"
                  textSize={{ xs: "27px", md: "display6" }}
                  m={{ b: "10px" }}
                  textAlign={{ xs: "center", md: "left" }}
                >
                  A Podcast for eCommerce and DTC Brands
                </Text>
                <Text
                  textSize="heading3"
                  d={{ xs: "none", md: "block" }}
                  m={{ b: "1.75rem" }}
                >
                  DTC POD is a podcast about all things direct to consumer. We
                  cover everything for starting, growing, and optimizing
                  eCommerce stores and DTC (or D2C) brands.
                </Text>
                <Div d={{ md: "flex" }} m={{ t: { xs: "2.75rem", md: "0" } }}>
                  <Div m={{ r: "14px" }}>
                    <AnimateLink
                      m={{ r: "14px" }}
                      to={
                        "https://podcasts.apple.com/us/podcast/tips-from-successful-shopify-stores/id1497055482?i=1000467562190"
                      }
                    >
                      <Button
                        bg="white"
                        textColor="black"
                        hoverBg="lightGray"
                        rounded="2px"
                        w="100%"
                        textWeight="800"
                        h="3.125rem"
                        p="0 1.875rem"
                      >
                        Subscribe on Apple
                      </Button>
                    </AnimateLink>
                  </Div>
                  <Div m={{ t: { xs: "1.25rem", md: "0" } }}>
                    <AnimateLink to="https://open.spotify.com/show/1xFuU7WqySKiIjrryue8Bp">
                      <Button
                        bg="white"
                        w="100%"
                        hoverBg="lightGray"
                        textColor="black"
                        rounded="2px"
                        textWeight="800"
                        h="3.125rem"
                        p="0 1.5rem"
                      >
                        Subscribe on Spotify
                      </Button>
                    </AnimateLink>
                  </Div>
                </Div>
              </Div>
              <Div
                d="flex"
                justify="center"
                align="center"
                order={{ xs: 1, md: 2 }}
              >
                <Div
                  w="100%"
                  d={{ xs: "none", md: "block" }}
                  bgImg="/images/DTC_Desktop.png"
                  p={{ b: "100%" }}
                  shadow="0px 0px 140px rgba(74, 0, 108, 0.59)"
                  bgPos="center"
                  bgSize="cover"
                  rounded="23px"
                ></Div>
                <Image
                  src="/images/DTC_Desktop.png"
                  h="8.375rem"
                  w="8.375rem"
                  d={{ md: "none" }}
                />
              </Div>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </Div>
  );
};

export default PodcastHero;
